import React, { Component } from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import cx from 'classnames';
import $ from 'jquery';

import { PAGE_EBOOK } from '../../../config/pages';

import EbookHeader from './EbookHeader';
import EbookContent from './EbookContent';
import Footer from '../common/Footer';
import Form from '../common/Form';
import { companyInfoPropsType } from '../../helpers/fetchCmsContent';

class Ebook extends Component {
    constructor(props) {
        super(props);
        this.scrollToForm = this.scrollToForm.bind(this);
    }

    scrollToForm() {
        const { breakpoint } = this.props;
        const ebookForm = $('.ebook-form');

        if (!ebookForm.length) {
            return;
        }

        if (breakpoint !== 'phone' && breakpoint !== 'tablet') {
            return;
        }

        const ebookFormOffsetTop = ebookForm.offset().top;
        const ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        if (ios) {
            window.scrollTo(0, ebookFormOffsetTop);
        } else {
            $('html, body').animate({
                scrollTop: ebookFormOffsetTop
            }, 1000);
        }
    }

    render() {
        const {
            t, openPage, language, page, subpage, breakpoint, consents, companyInfo
        } = this.props;
        const ebookClassName = cx('container-ebook', {
            open: page === PAGE_EBOOK
        });

        const ebooks = t('ebook.list');

        let ebookIndex = null;
        let ebook = null;
        if (subpage !== null) {
            ebookIndex = findIndex(ebooks, (o) => o.slug === subpage);
            if (ebookIndex !== -1) {
                ebook = ebooks[ebookIndex];
            }
        }

        if (ebook === null) {
            return (
                <div/>
            );
        }

        return (
            <div className={ ebookClassName } id={ ebookClassName }>
                <EbookHeader
                  t={ t }
                  subpage={ subpage }
                  language={ language }
                  breakpoint={ breakpoint }
                  scrollToForm={ this.scrollToForm }
                  ebook={ ebook }
                  showShadow={ ebookIndex === 0 }
                />
                <EbookContent
                  t={ t }
                  openPage={ openPage }
                  language={ language }
                  breakpoint={ breakpoint }
                  scrollToForm={ this.scrollToForm }
                  ebook={ ebook }
                  consents={ consents }
                />
                <Form type="bottom" t={ t } language={ language } formName="ebook-bottom" typeButton="offer" consents={ consents }/>
                <Footer t={ t } openPage={ openPage } language={ language } claim={ this.props.claim } companyInfo={ companyInfo }/>
            </div>
        );
    }
}

Ebook.defaultProps = {
    subpage: null,
    companyInfo: null
};

Ebook.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    claim: PropTypes.string.isRequired,
    breakpoint: PropTypes.string.isRequired,
    consents: PropTypes.objectOf(Object).isRequired,
    companyInfo: companyInfoPropsType

};

export default Ebook;



// WEBPACK FOOTER //
// ./src/components/content/ebook/Ebook.jsx